import React, { useEffect, useState } from "react";
import img from "../../assets/images/azlogomessage.jpeg";
import az_new_paper from "../../assets/images/az_new_paper.png";
import classified_icon_01 from "../../assets/images/classified_icon_01.png";
import classified_icon_02 from "../../assets/images/classified_icon_02.png";
import classified_icon_03 from "../../assets/images/classified_icon_03.png";
import classified_icon_04 from "../../assets/images/classified_icon_04.png";
import classified_icon_05 from "../../assets/images/classified_icon_05.png";
import classified_icon_06 from "../../assets/images/classified_icon_06.png";
import classified_icon_07 from "../../assets/images/classified_icon_07.png";
import classified_icon_08 from "../../assets/images/classified_icon_08.png";
import classified_icon_09 from "../../assets/images/classified_icon_09.png";
import classified_icon_10 from "../../assets/images/classified_icon_10.png";
import classified_icon_11 from "../../assets/images/classified_icon_11.png";
import classified_icon_12 from "../../assets/images/classified_icon_12.png";
import iconStar from "../../assets/images/prime_star.png";

import {
  getClassifieldCatData,
  getClassifieldPremiumData,
} from "../../services/HomeServices";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { minimizeName, plainString } from "../../lib/constant";

const iconArray = [
  classified_icon_01,
  classified_icon_02,
  classified_icon_03,
  classified_icon_04,
  classified_icon_05,
  classified_icon_06,
  classified_icon_07,
  classified_icon_08,
  classified_icon_09,
  classified_icon_10,
  classified_icon_12,
  classified_icon_11,
];

const ClassifiedDesign = ({ onlyClassified }) => {
  const [data, setdata] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [categories, setcategories] = useState([]);
  const navigate = useNavigate();
  let indexOfColor = 0;

  useEffect(() => {
    const controller = new AbortController();

    const timeout = setTimeout(() => {
      getData(1, 12, controller?.signal);
      getCategories(controller?.signal);
    }, 700);
    return () => {
      clearTimeout(timeout);
      controller.abort();
    };
  }, []);

  const getData = async (page, perPage, signal) => {
    setisLoading(true);
    await getClassifieldPremiumData(page, perPage, "", "", signal)
      .then((response) => {
        setdata(response?.data?.data?.data);
        setisLoading(false);
      })
      .catch((error) => {
        setisLoading(true);
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
          console.log("Aborted");
        } else {
          toast("Something went wrong", { type: "error" });
        }
      });
  };

  const getCategories = async (signal) => {
    await getClassifieldCatData(signal)
      .then((response) => {
        const array = response?.data?.data?.filter(
          (a) => a?.name !== "Pin Hopes"
        );
        setcategories(array);
      })
      .catch((error) => {
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
          console.log("Aborted");
        } else {
          toast("Something went wrong", { type: "error" });
        }
      });
  };

  return (
    <div>
      <div className="container-fluid bg_drackgray">
        <div className="container">
          <div className="row prime_listings">
            <div className="col-6">
              <h2>Prime Listings</h2>
            </div>
            <div className="col-6">
              {" "}
              <Link to="/classifield-post" className="btn_post">
                Post <i className="fas fa-plus" />
              </Link>{" "}
            </div>
          </div>
          <div className="row pt-4">
            {data?.slice(0, 8)?.map((x) => (
              <div
                className="col-sm-3 p-2"
                onClick={() => {
                  navigate(`/classifield-detail/${x?.id}`);
                }}
              >
                <div className="prime_card">
                  {" "}
                  <img
                    src={iconStar}
                    alt="star"
                    className="prime_star"
                    style={{
                      marginTop: "8px",
                    }}
                  />{" "}
                  <img
                    className="card-img-top"
                    style={{
                      width: "100%",
                      // ,minHeight:'206px'
                      height: "174px",
                      width: "274px",
                      // height: "23vh",
                    }}
                    src={x?.image || x?.images[0]?.image || img}
                    alt="Card image cap"
                  />
                  <p className="card-text line-clump-2">
                    {minimizeName(plainString(x?.description), 90)}
                    <divspan
                      onClick={() => navigate(`/classifield-detail/${x?.id}`)}
                      style={{
                        marginLeft: "10px",
                        cursor: "pointer",
                        fontWeight: "800",
                        color: "#ff6820",
                      }}
                    >
                      More
                    </divspan>
                    {/* <Link to={`/classifield-detail/${x?.id}`}>More</Link> */}
                  </p>
                  <div className="row">
                    {/* <div className="col-6">
                      <label>
                        <i className="far fa-calendar" /> Nov 24, 2024
                      </label>
                    </div> */}
                    {/* <div className="col-6">
                      <Link to={`/classifield-detail/${x?.id}`}>More</Link>
                    </div> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {!onlyClassified && (
        <div className="container-fluid classifieds_main bg_gray">
          <div className="container">
            <div className="row">
              <div className="col-sm-8">
                <div className="col-6">
                  <h2>Classifieds</h2>
                </div>
                <div className="row pt-4">
                  {categories?.map((x, i) => {
                    if (i > 10 && indexOfColor > 10) {
                      indexOfColor = 1;
                    } else {
                      indexOfColor++;
                    }

                    return (
                      <div className="col-sm-3">
                        <Link
                          to={`/classifield/${x?.id}`}
                          className={`classfi_icon cf_icon${indexOfColor} `}
                        >
                          <img
                            // style={{ height: "15vh" }}
                            src={iconArray[i] || classified_icon_07}
                            // src={x?.image || classified_icon_01}
                            alt="Art/Dance/Music"
                          />{" "}
                          <span>{minimizeName(x?.name)}</span>
                        </Link>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="col-sm-4">
                <div className="col-6">
                  <h2>News</h2>
                </div>
                <div className="row pt-4">
                  {" "}
                  <a href="http://www.azindiatimes.com/" target="_blank">
                    <img src={az_new_paper} alt="azindia new paper" />
                  </a>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClassifiedDesign;
